import { Controller } from '@hotwired/stimulus'

export default class NavigationItemController extends Controller {
  static values = {
    id: String,
    name: String,
    position: Number,
    isValid: Boolean,
    isCompleted: Boolean,
    isCurrent: Boolean
  }

  pageUpdated ({ detail: { id, isValid, isCompleted, isCurrent } }) {
    if (this.page.id === id) {
      this.isValidValue = isValid
      this.isCompletedValue = isCompleted
      this.isCurrentValue = isCurrent
    }
  }

  isCurrentValueChanged () {
    if (this.isCurrentValue) {
      this.element.classList.add('is-current', 'sticky', 'bottom-0', 'top-0')
    } else {
      this.element.classList.remove('is-current', 'sticky', 'bottom-0', 'top-0')
    }
  }

  isCompletedValueChanged () {
    if (this.isCompletedValue) {
      this.element.classList.add('is-completed')
    } else {
      this.element.classList.remove('is-completed')
    }
  }

  get page () {
    return {
      id: this.idValue,
      name: this.nameValue,
      position: this.positionValue,
      isValid: this.isValidValue,
      isCompleted: this.isCompletedValue,
      isCurrent: this.isCurrentValue
    }
  }
}
